import { render } from "./FormRichedit.vue?vue&type=template&id=25110385&scoped=true&ts=true"
import script from "./FormRichedit.vue?vue&type=script&lang=ts"
export * from "./FormRichedit.vue?vue&type=script&lang=ts"

import "./FormRichedit.vue?vue&type=style&index=0&id=25110385&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25110385"]])

export default __exports__